import React from "react";
import PropTypes from "prop-types";
import styles from "./Portfolio.css";

const portfolio = ({ display }) => {
  let displayClass = [styles.Portfolio, styles.PortfolioActive];
  if (!display) {
    displayClass = [styles.Portfolio, styles.PortfolioHidden];
  }

  return (
    <div className={displayClass.join(" ")}>
      <h1>Portfolio</h1>
      <h3>Portfolio coming soon!</h3>
    </div>
  );
};

portfolio.propTypes = {
  display: PropTypes.bool.isRequired
};

export default portfolio;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Portfolio/Portfolio.js